import $ from 'jquery'
import BaseUserDataSection from '../administration/userManagement/BaseUserDataSection'
import BaseUserInformationSection from '../administration/userManagement/BaseUserInformationSection'
import UserNameDrawer from '../administration/userManagement/UserNameDrawer'
import PasswordFieldsDrawer from '../administration/userManagement/PasswordFieldsDrawer'
import WorkdayDurationsEditor from '../controls/WorkdayDurationsEditor'
import { BalanceRulesViewer } from '../controls/BalanceRulesEditor'
import UserTime from '../user_time'
import { DateFormat } from '../date_format'
import ScrollUtils from '../util/ScrollUtils'
import messageResource from '../messageResource'
import PasswordPolicyManager from '../util/passwords/PasswordPolicyManager'
import PasswordHintLink from '../util/passwords/PasswordHintLink'
import { getPasswordValidator } from '../util/passwords/PasswordAsyncValidator'
import PasswordErrorMessage from '../util/passwords/PasswordErrorMessage'
import { ValidationErrors } from '../panels/user/constants'
import { checkElementOrAncestorHasClass } from '../atBrowserUtils'
import { AtNextCustomScrollbarUsedClassName } from '../next/constants'
import { DefaultWorkday } from './components/DefaultWorkday'

function UserProfileSection() {
}

UserProfileSection.OLD_PASSWORD_EMPTY = "oldPasswordEmpty";


UserProfileSection.prototype = new BaseUserInformationSection();

UserProfileSection.prototype.init = function(lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, isPTOEnabled, isSickEnabled, mailSettingsSpecified, isWSDEnabled, isDefaultWorkdaySectionShown) {
    var sectionId = "userProfileSection";
    var self = this;
    BaseUserInformationSection.prototype.init.call(this, {
        lightBoxEl: lightBoxEl,
        sectionId: sectionId,
        userData: userData,
        changesCallback: changesCallback,
        validateCallback: validateCallback,
        isInstantValidation: isInstantValidation,
        needValidation: true,
    });
    new PasswordHintLink({ passwordPolicy: PasswordPolicyManager }).init(this.$subId("passwordHintCell"));

    this.usernameFieldDrawer = new UserNameDrawer().init({
        getElementByIdFunction: function(subId) { return self.getElementBySubId(subId) },
        changeDetectedFunction: function(notRequireConfirmationOnCopySettings) { self.changesDetected(notRequireConfirmationOnCopySettings) },
        updateUICallback: function() {
            $.extend(self.errors, self.usernameFieldDrawer.getErrors());
            self.updateUI()
        },
        validationDetectedCallback: function() { self.validationDetected() }
    });
    this.usernameFieldDrawer.initFields({ username: userData.username, id: userData.userId });

    this.passwordFieldDrawer = new PasswordFieldsDrawer().init(
        {
            disableValidation: true,
            getElementByIdFunction: function(subId) { return self.getElementBySubId(subId) },
            changeDetectedFunction: function(notRequireConfirmationOnCopySettings) { self.changesDetected(notRequireConfirmationOnCopySettings) },

            updateUICallback: function() {
                $.extend(self.errors, self.passwordFieldDrawer.getErrors());
                self.updateUI()
            },
            validationDetectedCallback: function() { self.validationDetected() }
        }
    );
    this.passwordFieldDrawer.initFields(userData);
    this.passwordFieldDrawer.setPasswordFieldsPlaceholders();
    this.passwordFieldDrawer.passwordField.on("changed", () => {
        let { password, passwordCopy } = self.passwordFieldDrawer.getPlainPasswordValues();
        self.passwordAsyncValidator.setState({ password, passwordCopy, forcePasswordCheck: true });
    });

    this.passwordAsyncValidator = getPasswordValidator({
        ignoreBothEmptyness: true,
        onValidationEnd: (errorKey, passwordValidationJson) => {
            this.setPasswordError(errorKey, passwordValidationJson);
        }
    });
    this.passwordFieldsError = new PasswordErrorMessage({ additionalClass: "inlineErrorMessage" }).init(this.$subId("passwordErrorsContainer"));
    this.oldPasswordField = this.$subId("oldPasswordField");
    this.oldPasswordField.placeholder();

    this.oldPasswordField.keydown(this.onKeyPressedHandler);
    this.oldPasswordField.keyup(this.passChangedHandler);

    this.oldPasswordField.blur(() => {
        this._checkOldPasswordSet()
        this.errors[ValidationErrors.OLD_PASSWORD_INCORRECT] = false
        $.extend(this.errors, this.passwordFieldDrawer.validateFields())
        this.updateUI()
    })

    this.passwordFieldsContainer = this.$subId("passwordFieldsContainer");
    this.changePasswordSlider = this.$subId("changePassword");
    this.changePasswordSlider.click(function() {
        self.changePasswordSlider.toggleClass("shown");
        self.passwordFieldsContainer.toggleClass("shown");
        ScrollUtils.refreshCustomScroll(self.leftSectionScroll)
    });

    this.leftSectionScroll = ScrollUtils.addVerticalScroll($(".leftSection"), { isFaded: false });
    var currentTime = new DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(userData.currentTimeInTimeZone));
    $("#profileCurrentTime").html(currentTime);

    this.rightSectionScroll = ScrollUtils.addVerticalScroll($(".rightSection"), { isFaded: false });

    $(".rightSection").find('.scrollableContainer').on(ScrollUtils.getWheelEventName(), (e) => {
        if (checkElementOrAncestorHasClass(e.originalEvent.target, AtNextCustomScrollbarUsedClassName)) {
            this.rightSectionScroll.disable()
            setTimeout(() => {
                this.rightSectionScroll.enable()
            }, 0)
            e.stopPropagation()
        }
    })

    this.defaultWorkStatusesSection = document.getElementById("defaultWorkStatusesSection")

    if (isWSDEnabled) {
        var defaultWorkStatusesBuilder = new EditDefaultWorkStatusesBuilder().init(userData)
        defaultWorkStatusesBuilder.createDefaultWorkStatuses(
            this.sectionEl,
            this.defaultWorkStatusesSection,
            changesCallback,
            validateCallback,
            userData,
            function() {
                ScrollUtils.refreshCustomScroll(self.rightSectionScroll)
            },
            'workStatusProfilePlanningRow',
            'workStatusProfileSelect',
            'workStatusProfileSelectLabel',
            true,
            true
        )
    }

    if (isDefaultWorkdaySectionShown) {
        this.defaultWorkdaySection = document.getElementById("defaultWorkdaySection")
        this.defaultWorkday = new DefaultWorkday().init(
            this.defaultWorkdaySection,
            userData,
            changesCallback,
            function() {
                ScrollUtils.refreshCustomScroll(self.rightSectionScroll)
            }
        )
    }

    var workdayDurationsEditor = new WorkdayDurationsEditor().init(userData.effectiveSchedule, window.SystemSettings.weekStartDay, function() {
    }, true, null, window.SystemSettings.decimalSeparator, true);
    workdayDurationsEditor.onBlur = workdayDurationsEditor.onFocus = function() { };
    var edTotalEl = document.getElementById("weekTotalPlaceholder");
    edTotalEl.innerHTML = UserTime.formatTime(WorkdayDurationsEditor.sumDurations(userData.effectiveSchedule));

    workdayDurationsEditor.renderTo(document.getElementById("schedulePlaceholder"));
    workdayDurationsEditor.setInputDisabled(true);

    var showPTORules = isPTOEnabled && userData.pto;
    var showSickRules = isSickEnabled && userData.sick;

    var balanceRulesSection = document.getElementById("profileBalanceRulesSection");
    if (showPTORules || showSickRules) {
        var balanceRulesSectionHeaderMsgKey = showPTORules ?
            (showSickRules ? "profile.right_section.block_header_pto_sick_rules" :
                "profile.right_section.block__pto_sick_rules.pto") :
            "profile.right_section.block__pto_sick_rules.sick";
        $(balanceRulesSection).find(".sectionHeader").html(messageResource.getMessage(balanceRulesSectionHeaderMsgKey));

        var ptoRulesSection = document.getElementById("ptoRulesSection");
        var userToday = Date.parseJSONTimeWithoutTimeZone(userData.currentTimeInTimeZone).toJSON()

        if (showPTORules) {
            this._pto_rulesViewer = new BalanceRulesViewer();
            this._pto_rulesViewer.init("pto", ptoRulesSection, true, 8, undefined, true, userToday);
            $(ptoRulesSection).toggleClass("default", userData.ptoRules.defaultRules);
            this._pto_rulesViewer.setValues(this._pto_rulesViewer._getValuesFromBalanaceData(userData.ptoRules));
            this._pto_rulesViewer.setDefaultBalanceData(userData.defaultPtoRules);
            this._pto_rulesViewer._fillElementsWithValues(userData.ptoRules.defaultRules, true, true);
        }
        else {
            $(ptoRulesSection).hide();
        }

        var sickDaysRulesSection = document.getElementById("sickDaysRulesSection");
        if (showSickRules) {
            this._sickDaysRulesViewer = new BalanceRulesViewer();
            this._sickDaysRulesViewer.init("sick", sickDaysRulesSection, true, 8, undefined, true, userToday);
            $(sickDaysRulesSection).toggleClass("default", userData.sickDaysRules.defaultRules);
            this._sickDaysRulesViewer.setValues(this._sickDaysRulesViewer._getValuesFromBalanaceData(userData.sickDaysRules));
            this._sickDaysRulesViewer.setDefaultBalanceData(userData.defaultSickDaysRules);
            this._sickDaysRulesViewer._fillElementsWithValues(userData.sickDaysRules.defaultRules, true, true);
        }
        else {
            $(sickDaysRulesSection).hide();
        }
    }
    else {
        $(balanceRulesSection).hide();
    }

    // TODO: notifications are disabled for now, remove or rewrite later
    // this.receiveUserChangesChBox = this.$subId("receiveUserChangesChBox");
    // this.receiveUserChangesChBox.attr('checked', userData.receiveUserChangesNotification);
    // this.receiveUserChangesChBox.change(function() { self.changesDetected(); });
    // if (!mailSettingsSpecified) {
    //     this.receiveUserChangesChBox.attr('disabled', true);
    // }

    // this.receiveCommentsChangesChBox = this.$subId("receiveCommentsChangesChBox");
    // this.receiveCommentsChangesChBox.attr('checked', userData.receiveCommentsChangesNotification);
    // this.receiveCommentsChangesChBox.change(function() { self.changesDetected(); });
    // if (!mailSettingsSpecified) {
    //     this.receiveCommentsChangesChBox.attr('disabled', true);
    // }

    return this;
};

UserProfileSection.prototype.setPasswordError = function(errorKey, passwordValidationResult) {
    this.passwordFieldsError.setState({ passwordValidationResult })
    this.passwordFieldDrawer.setError(errorKey)
    this.validationDetected();
    this.updateUI();
}

UserProfileSection.prototype.setOldPasswordIncorrectError = function() {
    this.errors[ValidationErrors.OLD_PASSWORD_INCORRECT] = true
    this.updateUI()
}

UserProfileSection.prototype.customValidate = function(oldErrors) {
    $.extend(this.errors, this.passwordFieldDrawer.validateFields(oldErrors), this.usernameFieldDrawer.validateFields(oldErrors));
    this._checkOldPasswordSet();
    if (this.defaultWorkday) {
        $.extend(this.errors, this.defaultWorkday.validate())
    }

    this._showPasswordFieldsIfNeeded();
};

UserProfileSection.prototype._showPasswordFieldsIfNeeded = function() {
    var self = this;
    var isPasswordFieldsHasError = function() {
        var errors = self.passwordFieldDrawer.getErrors();
        for (var errorName in errors) {
            if (errors.hasOwnProperty(errorName) && errors[errorName]) {
                return true;
            }
        }
        return false;
    };
    if (this.errors[UserProfileSection.OLD_PASSWORD_EMPTY] || isPasswordFieldsHasError()) {
        this.changePasswordSlider.addClass("shown");
        this.passwordFieldsContainer.addClass("shown");
    }
};

UserProfileSection.prototype.validationDetected = function() {
    $.extend(this.errors, this.passwordFieldDrawer.getErrors(), this.usernameFieldDrawer.getErrors());
    BaseUserDataSection.prototype.validationDetected.call(this);
};

UserProfileSection.prototype._checkOldPasswordSet = function() {
    var oldPswEmpty = this.oldPasswordField.pVal().length === 0;

    this.passwordFieldDrawer.setPasswordsAreMandatory(!oldPswEmpty)

    this.passwordValues = this.passwordFieldDrawer.getPlainPasswordValues();

    var pswEmpty = this.passwordValues.password.length === 0;
    var pswCopyEmpty = this.passwordValues.passwordCopy.length === 0;

    this.errors[UserProfileSection.OLD_PASSWORD_EMPTY] = oldPswEmpty && (!pswEmpty || !pswCopyEmpty);
    return this.errors[UserProfileSection.OLD_PASSWORD_EMPTY];
};

UserProfileSection.prototype.setUsernameDuplicateError = function() {
    $.extend(this.errors, this.usernameFieldDrawer.setDuplicateNameError());
    this.validate();
    this.updateUI();
};

UserProfileSection.prototype.getOldPassword = function() {
    var passwordValue = this.oldPasswordField.pVal();
    return passwordValue.length > 0 ? passwordValue : null;
};

UserProfileSection.prototype.getNewPassword = function() {
    return this.passwordFieldDrawer.getNewPassword();
};

UserProfileSection.prototype.getUsername = function() {
    return this.usernameFieldDrawer.getObjectValues().username;
};

// TODO: notifications are disabled for now, remove or rewrite later
// UserProfileSection.prototype.getReceiveUserChangesOption = function() {
//     return this.receiveUserChangesChBox.attr('checked') === 'checked';
// };

// UserProfileSection.prototype.getReceiveCommentsChangesOption = function() {
//     return this.receiveCommentsChangesChBox.attr('checked') === 'checked';
// };

export default UserProfileSection



// WEBPACK FOOTER //
// ./web/js/userProfile/UserProfileSection.js